import PropTypes from "prop-types";
import DateSearchHero from "../heros/DateSearchHero";
import { formatTime } from "../configs/formatTime";
import DataTable from "../DataTables/DataTable";
import StatusBadge from "../assests/StatusBadge";
import { formatToDate } from "../configs/formatToDate";

function UserAppointmentTable(props) {
  const { appointmentList, loading, handleDate, handleSearch } =
    props;

  const columns = [
    {
      title: "BOOKING ID",
      dataIndex: "booking_id",
      // sorter: (a, b) => a.bookingid.length - b.bookingid.length,
    },
    {
      title: "TYPE",
      dataIndex: "type",
      // sorter: (a, b) => a.type.length - b.type.length,
    },
    {
      title: "PATIENT NAME",
      dataIndex: "patientname",
      // sorter: (a, b) => a.patientname.length - b.patientname.length,
      render: (_item, record) => (
        <div>{record?.user_details?.name ?? record?.user?.first_name}</div>
      ),
    },
    {
      title: "ASSIGNED DOCTOR",
      dataIndex: "assingned",
      render: (_item, record) =>
        record?.doctor?.name ? (
          <div>Dr.{record?.doctor?.name}</div>
        ) : (
          <div>N/A</div>
        ),
    },

    {
      title: "TIME SLOT",
      dataIndex: "timeSlot",
      // sorter: (a, b) => a.time.length - b.time.length,
      render: (_item, record) => (
        <div>{_item ? formatTime(record?.timeSlot) : "unassigned"}</div>
      ),
    },

    {
      title: "APPOINTMENT DATE",
      dataIndex: "appointmentDate",
      render: (item) => <div>{formatToDate(item)}</div>,
      sorter: (a, b) => {
        return new Date(a.appointmentDate) - new Date(b.appointmentDate);
      },
    },
    {
      title: "STATUS",
      dataIndex: "status",
      render: (item) => (
        <div>
          <StatusBadge status={item} />
        </div>
      ),
    },
  ];

  return (
    <div>
      <DateSearchHero
        handleDate={handleDate}
        handleSearch={handleSearch}
      />
      <div className="table-responsive">
        <DataTable
          columns={columns}
          data={appointmentList ?? []}
          loading={loading}
        />
      </div>
    </div>
  );
}

UserAppointmentTable.propTypes = {
  appointmentList: PropTypes.node,
  loading: PropTypes.bool,
  handleDate: PropTypes.func,
  handleSearch: PropTypes.func,
};

export default UserAppointmentTable;
